"use client"

import { Typography, Row, Col, Layout } from "antd"
import { WhatsAppOutlined, InstagramOutlined, EnvironmentOutlined } from "@ant-design/icons"
import styles from "./RodapeComponent.module.css" // Importando o CSS Module

const { Text } = Typography
const { Footer } = Layout

const RodapeComponent = () => {
  return (
    // O ideal é usar este componente dentro da tag <Layout.Footer> no seu arquivo de layout principal (ex: App.tsx)
    // Mas para manter a estrutura, usamos o componente Footer do Ant Design aqui.
    <Footer className={styles.footer}>
      <div className={styles.container}>
        <Row align="middle" gutter={[16, 16]}>
          {/* Coluna de Contatos */}
          <Col xs={24} md={8} className={`${styles.footerCol} ${styles.colContatos}`}>
            <div className={styles.infoBlock}>
              <Text className={styles.infoLabel}>Contatos:</Text>
              <a
                href="https://wa.me/5586994321635"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                <WhatsAppOutlined />
                <Text style={{ color: "inherit" }}>(86) 99432-1635</Text>
              </a>
              <a
                href="https://www.instagram.com/durafixoficial"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.infoLink}
              >
                <InstagramOutlined />
                <Text style={{ color: "inherit" }}>@durafixoficial</Text>
              </a>
            </div>
          </Col>

          {/* Coluna de Direitos Autorais */}
          <Col xs={24} md={8} className={`${styles.footerCol} ${styles.colCopyright}`}>
            <Text className={styles.copyrightText}>
                {new Date().getFullYear()} | Durafix - Todos os direitos reservados
            </Text>
          </Col>

          {/* Coluna de Endereço */}
          <Col xs={24} md={8} className={`${styles.footerCol} ${styles.colEndereco}`}>
            <div className={styles.infoBlock}>
              <Text className={styles.infoLabel}>Endereço:</Text>
              <div className={styles.infoText}>
                <EnvironmentOutlined />
                <Text style={{ color: "inherit" }}>Rua C, Nº 148 - Distrito Industrial</Text>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Footer>
  )
}

export default RodapeComponent